'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    GET_SCREEN_DATA,
    GET_SCREEN_DATA_RESULT_NUEVA_SOLICITUD,
    RESET_ALL,
    SET_FUNCIONES_DE_USUARIO,
    ADD_TARJETA,
    CHANGE_DOMICILIO,
    CHANGE_TITULAR,
    CHANGE_SHOW_ERROR,
    CHANGE_LIMITE,
    CHANGE_PRODUCTO_IBS,
    FINALIZAR_GUARDADO,
    RESETE_VALUES_NEW_TARJETA,
    LIMPIAR_ESTADO_NUEVA_SOLICITUD,
    VALIDAR_NUEVA_SOLICITUD,
    MOSTRAR_SPINNER_GUARDADO
} from '../../Screens/NuevaSolicitud/actions/Actions';

/**
 * Estado inicial.
 */
const initialState = {
    loading: false,
    functions: undefined,
    responsables: undefined,
    limites: undefined,
    productosIbs: undefined,
    error: false,
    todoOk: false,
    seEstaGuardando: false,
    cuentaSeleccionada: undefined,
    responsableSeleccionado: 0,
    limitesSeleccionado: 0,
    productoibsSeleccionado: 0,
    domicilioSeleccionado: 0,

};


function nuevaSolicitudDelivery(state = initialState, action) {

    let result;
    switch (action.type) {
        case GET_SCREEN_DATA:

            result = {
                ...state,
                loading: true
            };
            break;

        case GET_SCREEN_DATA_RESULT_NUEVA_SOLICITUD:

            if (action.result.limites !== undefined)
                action.result.limites.unshift({ Id: 0, LimiteDescripcion: 'Seleccione...' });
            if (action.result.productosIbs !== undefined)
                action.result.productosIbs.unshift({ Id: 0, Descripcion: 'Seleccione...' });
            if (action.result.responsables !== undefined)
                action.result.responsables.unshift({ CliVinCod: 0, Cliente: 'Seleccione...'});

            result = {
                ...state,
                limites: action.result.limites,
                productosIbs: action.result.productosIbs,
                cuentaSeleccionada: action.cuenta,
                responsables: action.result.responsables,
                loading: false
            };
            break;

        case RESET_ALL:

            result = {
                ...state,
                loading: false,
            };
            break;

        case SET_FUNCIONES_DE_USUARIO:
            result = {
                ...state,
                functions: action.funciones
            };
            break;

        case RESETE_VALUES_NEW_TARJETA:
            result = {
                ...state,
                responsableSeleccionado: 0,
                limitesSeleccionado: 0,
                productoibsSeleccionado: 0,
                domicilioSeleccionado: 0
            };
            break;

        case CHANGE_DOMICILIO:
            result = {
                ...state,
                domicilioSeleccionado: action.domicilio
            };
            break;

        case CHANGE_TITULAR:
            result = {
                ...state,
                responsableSeleccionado: action.responsable
            };
            break;

        case CHANGE_SHOW_ERROR:
            result = {
                ...state,
                error: action.isError
            };
            break;

        case CHANGE_LIMITE:
            result = {
                ...state,
                limitesSeleccionado: action.idLimite
            };
            break;

        case FINALIZAR_GUARDADO:
            result = {
                ...state,
                todoOk: true,
                seEstaGuardando: false,
                mostrarError: false
            };
            break;

        case CHANGE_PRODUCTO_IBS:
            let productoIbs = state.productosIbs.find(x => x.Id == action.idProductoIbs); let limite;
            if (productoIbs !== undefined)
                limite = productoIbs.TdLimiteCredId;

            result = {
                ...state,
                productoibsSeleccionado: action.idProductoIbs,
                limitesSeleccionado: limite = undefined ? 0 : limite
            };
            break;
        case LIMPIAR_ESTADO_NUEVA_SOLICITUD: {
            result = initialState;
            break;
        }
        case VALIDAR_NUEVA_SOLICITUD: {
            result = {
                ...state,
                todoOk: action.resultado,
                error: true
            }
            break;
        }

        case MOSTRAR_SPINNER_GUARDADO: {
            result = {
                ...state,
                seEstaGuardando: true

            }
            break;
        }

        default:

            result = {
                ...state
            };
            break;
    }
    return result;
}

export default nuevaSolicitudDelivery;